module.exports = __webpack_public_path__ + "img/circle.e3c5a650.svg";